<template>
    <div>
        <Toolbar>
            <BackButton :to="__('general.offers')" :href="$route('offers')"/>
        </Toolbar>

        <LoadWidgetTemplateModal :visible="loadTemplateVisible"
                                 :templates="templates"
                                 @update:visible="v => loadTemplateVisible = v"
                                 @template:load="loadTemplate"
        />

        <Card>
            <template v-slot:icon>
                <i class="fas fa-code"/>
            </template>
            <template v-slot:title>
                {{ __('actions.embed_thing', {thing: __('general.widget')}) }}
            </template>
            <template v-slot:description>
                {{ __('offers.place_on_website_info') }}
            </template>
            <template v-slot:toolbar>
                <div class="btn-group">
                    <button class="btn btn-default btn-hover-primary px-5" @click="loadTemplateVisible = true">
                        <i class="fas fa-upload"/>
                        {{ __('actions.load_thing', {thing: __('general.template')}).ucfirst() }}
                    </button>
                    <button class="btn btn-default btn-hover-primary px-5" @click="saveTemplate">
                        <i class="fas fa-save"/>
                        {{ __('actions.save_thing', {thing: __('general.template')}).ucfirst() }}
                    </button>
                </div>
            </template>

            <!-- Page -->
            <div v-if="mixFile" class="row">
                <div class="col-xl-5">
                    <WidgetSettingsForm v-model="settings"
                                        :key="settingsUpdates"
                    />
                </div>
                <div class="col-xl-6 offset-xl-1">
                    <EmbedCodeInfoBox :offer="offer"
                                      :encoded-store-uuid="encodedStoreUuid"
                                      :settings="settings"
                                      :mix-file="mixFile"
                    />
                </div>
            </div>
            <div v-else>
                {{ __('general.loading') }}...
            </div>
        </Card>
    </div>
</template>

<script>
import Card from '@components/Cards/Card.vue';
import Toolbar from '@components/Toolbar.vue';
import BackButton from '@components/BackButton.vue';
import EmbedCodeInfoBox from '@components/SelectedOffers/Embed/EmbedCodeInfoBox.vue';
import WidgetSettingsForm from '@components/SelectedOffers/Embed/WidgetSettingsForm.vue';
import Modal from '@components/Modal.vue';
import LoadWidgetTemplateModal from '@components/SelectedOffers/Embed/LoadWidgetTemplateModal.vue';

export default {
    components: {
        LoadWidgetTemplateModal,
        Modal,
        WidgetSettingsForm,
        EmbedCodeInfoBox,
        BackButton,
        Toolbar,
        Card,
    },

    props: {
        offer: Object,
        encodedStoreUuid: String,
        templates: Array,
        showLoadTemplate: Boolean,
    },

    data() {
        return {
            mixFile: 'widgets/1.1/script',
            settingsUpdates: 0,
            loadTemplateVisible: this.showLoadTemplate,
            settings: {
                type: 'slider',
                title: true,
                columns: 3,
                gutter: 10,
                color: '#795BF3',
                show_bg: true,
                border: true,
                autoplay: true,
                autoplayDelay: 5,
                button: true,
                new_tab: false,
            },
        };
    },

    methods: {
        saveTemplate() {
            Swal.fire({
                title: __('offers.specify_name'),
                input: 'text',
                showCancelButton: true,
                cancelButtonText: __('actions.abort'),
                confirmButtonText: __('actions.submit'),
                customClass: {
                    confirmButton: 'btn btn-primary m-0 bg-primary',
                },
            }).then((result) => {
                if (result.value.trim() !== '') {
                    this.$inertia.put(this.$route('offers.widgets.templates'), {
                        name: result.value,
                        settings: this.settings,
                    }, {
                        only: ['templates'],
                        onSuccess: () => {
                            toastr.success(__('general.thing.saved', {thing: __('general.template')}));
                        },
                    });
                }
            });
        },

        loadTemplate(template) {
            this.settings = template.settings;
            this.settingsUpdates++;
            this.loadTemplateVisible = false;
        },
    },
};
</script>
